import { useMemo, useState } from "react";
import { axiosGetWithHeader } from "../../Common/axios";
import { handleClickColor } from "../../Common/Util";
import Spinner from 'react-bootstrap/Spinner';

export function KPCuspalLinksSubLord ({userData}) {
  const [chartData, setChartData] = useState([]);
  const [spinner, setSpinner] = useState('Loading - Cuspal Links Sub Lord Page');

  useMemo(() => {
    if(userData===null||userData===undefined) {
      return;
    }
    var clientId = userData.id;
    axiosGetWithHeader("/chart/cuspallinksublord/"+clientId,
      (response)=>{
        setChartData(response.data);
        setSpinner(null);
      },
      (error)=>{
        console.log(error);
        setChartData([]);
        setSpinner(null);
      }
    );

  }, [userData]);

    return(
      <>
        {spinner===null?<></>:<>{spinner} <Spinner animation="border" size="sm" /></>}
        {  
          chartData===null||chartData.length===0?(
            <></>
          ):(
          <table class="table table-bordered table-hover align-middle caption-top m-0 p-0 text-center TableFont">
          <caption class="m-0 p-0" ><h5 class="m-0 p-2">Cuspal Links - Sub Lord</h5></caption>
          <thead>
            <tr class="p-0">
              <th class="p-0 kptable-td">House</th> 
              <th class="p-0 kptable-td">Sub Lord (A)</th> 
              <th class="p-0 kptable-td">Star Lord of A</th> 
              <th class="p-0 kptable-td">Sub Lord of A</th> 
            </tr>
          </thead>
          <tbody>
          {
            chartData.map((planet) => (
                <tr class="p-0" onClick={handleClickColor}>
                    <th class="bg-transparent text-start p-0 ps-1 kptable-td">{planet[0]}</th>
                    <td class="bg-transparent text-start p-0 ps-1 kptable-td">{planet[1]}</td>
                    <td class="bg-transparent text-start p-0 ps-1 kptable-td">{planet[2]}</td>
                    <td class="bg-transparent text-start p-0 ps-1 kptable-td">{planet[3]}</td>
                </tr>
            ))
          }
            </tbody>  
          </table>
          )
        }
        </>
      );
  }